import { createAsyncThunk } from "@reduxjs/toolkit";
import { AnalyticsState } from "./types";

import axios from "axios";

const { REACT_APP_SHOP_URL } = process.env;

export const trackEvent = createAsyncThunk(
  "analytics/track_event",
  async (data: AnalyticsState, { getState }): Promise<void> => {
    try {
      const state = getState() as any;

      await axios.post(`${REACT_APP_SHOP_URL}/api/v1/shop/client/analytics`, {
        sessionId: state.analytics.sessionId,
        apiKey: state.analytics.apiKey,
        pluginType: "chatapp",
        ...data,
      });

      return;
    } catch (err) {
      console.error(err);
      const message = (err as Error).message;
      throw new Error(message);
    }
  }
);
